import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PendingPaymentInModel } from '../../Models/Models/Payments/Deposits/PendingPaymentInModel';

declare var IS_RUNNING_IN_APP_POOL;

export class CancelRegularPaymentsInClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(cashEntryId: number, subAccountHierarchyId: string): Promise<Array<PendingPaymentInModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/CancelRegularPaymentsIn/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { cashEntryId: cashEntryId, subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.post<Array<PendingPaymentInModel>, any>(url, data);
  }
}

